import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Bookmark, Clock, Award, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const Dashboard = () => {
  const {
    user
  } = useAuth();
  // Mock data for dashboard
  const activeBookings = 2;
  const pastTrips = 5;
  const rewardPoints = user?.rewardPoints || 0;
  const upcomingTrips = [{
    id: 'trip-1',
    name: 'Classic Umrah Package',
    date: '15 Dec 2023',
    status: 'Confirmed',
    image: 'https://images.unsplash.com/photo-1591221668516-0d6c8c7eb11b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80'
  }, {
    id: 'trip-2',
    name: 'Thailand Delight',
    date: '3 Jan 2024',
    status: 'Pending Payment',
    image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80'
  }];
  const recentOrders = [{
    id: 'order-1',
    product: 'Travel Prayer Mat',
    date: '28 Nov 2023',
    status: 'Delivered',
    price: 49.99
  }, {
    id: 'order-2',
    product: 'Digital Quran Reader',
    date: '15 Nov 2023',
    status: 'Shipped',
    price: 129.99
  }];
  return <div data-id="element-712">
      <div className="mb-8" data-id="element-713">
        <h1 className="text-3xl font-bold text-navy-900" data-id="element-714">
          Welcome, {user?.fullName}
        </h1>
        <p className="text-navy-600 mt-2" data-id="element-715">
          Manage your bookings, orders, and account settings
        </p>
      </div>
      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-716">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-717">
          <div className="flex items-center mb-4" data-id="element-718">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-719">
              <Bookmark size={24} className="text-blue-600" data-id="element-720" />
            </div>
            <div data-id="element-721">
              <h3 className="text-lg font-medium text-navy-900" data-id="element-722">
                Active Bookings
              </h3>
              <p className="text-3xl font-bold text-navy-900" data-id="element-723">
                {activeBookings}
              </p>
            </div>
          </div>
          <Link to="/dashboard/bookings" className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-724">
            View Bookings
            <ChevronRight size={16} className="ml-1" data-id="element-725" />
          </Link>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-726">
          <div className="flex items-center mb-4" data-id="element-727">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4" data-id="element-728">
              <Clock size={24} className="text-green-600" data-id="element-729" />
            </div>
            <div data-id="element-730">
              <h3 className="text-lg font-medium text-navy-900" data-id="element-731">Past Trips</h3>
              <p className="text-3xl font-bold text-navy-900" data-id="element-732">{pastTrips}</p>
            </div>
          </div>
          <Link to="/dashboard/trips" className="text-green-600 hover:text-green-800 text-sm font-medium flex items-center" data-id="element-733">
            View History
            <ChevronRight size={16} className="ml-1" data-id="element-734" />
          </Link>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-735">
          <div className="flex items-center mb-4" data-id="element-736">
            <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mr-4" data-id="element-737">
              <Award size={24} className="text-gold-600" data-id="element-738" />
            </div>
            <div data-id="element-739">
              <h3 className="text-lg font-medium text-navy-900" data-id="element-740">
                Reward Points
              </h3>
              <p className="text-3xl font-bold text-navy-900" data-id="element-741">{rewardPoints}</p>
            </div>
          </div>
          <Link to="/dashboard/rewards" className="text-gold-600 hover:text-gold-800 text-sm font-medium flex items-center" data-id="element-742">
            View Rewards
            <ChevronRight size={16} className="ml-1" data-id="element-743" />
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-744">
        {/* Upcoming Trips */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-745">
          <div className="p-6 border-b border-gray-200" data-id="element-746">
            <h2 className="text-xl font-bold text-navy-900" data-id="element-747">Upcoming Trips</h2>
          </div>
          <div className="divide-y divide-gray-200" data-id="element-748">
            {upcomingTrips.map(trip => <div key={trip.id} className="p-6 flex items-center" data-id="element-749">
                <img src={trip.image} alt={trip.name} className="w-16 h-16 object-cover rounded-md mr-4" data-id="element-750" />
                <div className="flex-grow" data-id="element-751">
                  <h3 className="font-medium text-navy-900" data-id="element-752">{trip.name}</h3>
                  <p className="text-navy-600 text-sm" data-id="element-753">{trip.date}</p>
                  <span className={`inline-block px-2 py-1 text-xs rounded mt-1 ${trip.status === 'Confirmed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-754">
                    {trip.status}
                  </span>
                </div>
                <Link to={`/dashboard/bookings/${trip.id}`} className="text-navy-600 hover:text-navy-900" data-id="element-755">
                  <ChevronRight size={20} data-id="element-756" />
                </Link>
              </div>)}
            {upcomingTrips.length === 0 && <div className="p-6 text-center text-navy-600" data-id="element-757">
                No upcoming trips found.
              </div>}
          </div>
          <div className="p-4 border-t border-gray-200 bg-gray-50" data-id="element-758">
            <Link to="/dashboard/bookings" className="text-navy-900 hover:text-navy-700 font-medium text-sm flex items-center justify-center" data-id="element-759">
              View All Bookings
              <ChevronRight size={16} className="ml-1" data-id="element-760" />
            </Link>
          </div>
        </div>
        {/* Recent Orders */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-761">
          <div className="p-6 border-b border-gray-200" data-id="element-762">
            <h2 className="text-xl font-bold text-navy-900" data-id="element-763">Recent Orders</h2>
          </div>
          <div className="divide-y divide-gray-200" data-id="element-764">
            {recentOrders.map(order => <div key={order.id} className="p-6" data-id="element-765">
                <div className="flex justify-between items-start" data-id="element-766">
                  <div data-id="element-767">
                    <h3 className="font-medium text-navy-900" data-id="element-768">
                      {order.product}
                    </h3>
                    <p className="text-navy-600 text-sm" data-id="element-769">{order.date}</p>
                    <span className={`inline-block px-2 py-1 text-xs rounded mt-1 ${order.status === 'Delivered' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-770">
                      {order.status}
                    </span>
                  </div>
                  <div className="text-right" data-id="element-771">
                    <p className="font-bold text-navy-900" data-id="element-772">${order.price}</p>
                    <Link to={`/dashboard/orders/${order.id}`} className="text-gold-500 hover:text-gold-700 text-sm font-medium" data-id="element-773">
                      View Details
                    </Link>
                  </div>
                </div>
              </div>)}
            {recentOrders.length === 0 && <div className="p-6 text-center text-navy-600" data-id="element-774">
                No recent orders found.
              </div>}
          </div>
          <div className="p-4 border-t border-gray-200 bg-gray-50" data-id="element-775">
            <Link to="/dashboard/orders" className="text-navy-900 hover:text-navy-700 font-medium text-sm flex items-center justify-center" data-id="element-776">
              View Order History
              <ChevronRight size={16} className="ml-1" data-id="element-777" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default Dashboard;